<template>
    <div ref="loginView" class="login-view">
        <div class="main-border-header">
            <div v-if="!showResetPage" class="border-header-view">
                <div @click="pageActive = 1" :class="pageActive === 1 && 'item-activity'" class="border-view-item item-left">
                    <span style="flex: 1">登录</span>
                    <div style="width: 30px;height: 4px;position: absolute;bottom: 0;right: 0;left: 0;margin: auto;"
                         :style="pageActive === 1 && 'background-color: #7a69be;'"></div>
                </div>

                <div @click="pageActive = 2" :class="pageActive === 2 && 'item-activity'" class="border-view-item item-right">
                    <span style="flex: 1">注册</span>
                    <div style="width: 30px;height: 4px;position: absolute;bottom: 0;right: 0;left: 0;margin: auto;"
                         :style="pageActive === 2 && 'background-color: #7a69be;'"></div>
                </div>
            </div>

            <div v-else style="display: flex;margin-left: 5px;font-weight: bold;">
                <div @click="backLoginPage" style="width: 40px;height: 40px;display: flex;align-items: center;justify-content: center;cursor: pointer">
                    <van-icon name="arrow-left" color="#333333" size="20"/>
                </div>
                <div  @click="pageActive = 3" style="width: 80px;height: 40px;position: relative; cursor: pointer;display: flex;align-items: center;margin-left: 10px;">
                    <span :style="pageActive === 3 && 'color: #7a69be'" style="flex: 1">重置密码</span>
                    <div style="width: 30px;height: 4px;position: absolute;bottom: 0;right: 0;left: 0;margin: auto;" :style="pageActive === 3 && 'background-color: #7a69be;'"></div>
                </div>
            </div>
        </div>

        <img src="../assets/logo/logo-main.png" class="logo-img">

        <div v-if="pageActive === 1" class="login-form">
            <span class="ds-label" style="margin-top: 2px;font-weight: bold">{{ this.webName }}账号</span>
            <van-field label-width="60" label="" style="background-color: rgba(122,105,190,0.03);margin-top: 10px;"
                       :placeholder="`请输入${ this.webName }账号`" v-model="account" clearable>
            </van-field>

            <span class="ds-label" style="margin-top: 20px;font-weight: bold">密码</span>
            <van-field label-width="60" type="password" label=""
                       style="background-color: rgba(122,105,190,0.03);margin-top: 10px;"
                       placeholder="请输入登录密码" v-model="password" clearable>

                <template #button>
                    <span @click="toResetPage" style="color: #888888;font-size: 12px;cursor: pointer;">忘记密码?</span>
                </template>
            </van-field>

            <van-checkbox v-model="loginAgree" icon-size="14px" shape="square" checked-color="#7a69be" style="margin-top: 10px;">
                <div style="font-size: 12px;text-align: left;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">
                    我已阅读并同意
                    <span @click="openUserAgreement" style="color: #7a69be;">《用户协议》</span>
                    <span @click="openPrivacy" style="color: #7a69be;">《隐私政策》</span>
                </div>
            </van-checkbox>

            <div style="width: 100%;position: relative;">
                <van-button type="info" @click="submitLogin" round native-type="submit" :loading="loading"
                            style="width: 150px; height: 40px;margin-top: 20px;font-size: 14px;font-weight: bold"
                            loading-text="登录中"
                            color="#7a69be">
                    登 录
                </van-button>

            </div>

        </div>

        <div v-if="pageActive === 2" class="login-form" style="padding: 0 25px;">

            <van-field label-width="60" :label="registerType === 1 ? '账号' : '手机号码'" style="background-color: rgba(122,105,190,0.03);margin-top: 10px;"
                       :placeholder="registerType === 1 ? '请输入账号' : '请输入手机号码'" v-model="r_account" clearable>
            </van-field>

            <van-field label-width="60" type="password" label="密码"
                       style="background-color: rgba(122,105,190,0.03);margin-top: 10px;"
                       placeholder="请输入密码" v-model="r_password" clearable/>

            <van-field v-if="registerType === 1" label-width="60" type="password" label="确认密码"
                       style="background-color: rgba(122,105,190,0.03);margin-top: 10px;"
                       placeholder="请再次输入密码" v-model="r_password1" clearable/>

            <van-field v-show="registerType === 2" label-width="60" label="验证码" v-model="r_code" type="number"
                       style="background-color: rgba(122,105,190,0.03);margin-top: 10px;"
                       placeholder="请输入验证码" clearable>
                <template #button>
                    <van-count-down
                        v-show="showCountDown"
                        ref="countDown"
                        :time="60000"
                        :auto-start="false"
                        format="重新发送(ss秒)"
                        style="font-size: 14px;color: #888888"
                        @finish="finish"/>
                    <span style="color: #7a69be;font-size: 13px;cursor: pointer" v-show="!showCountDown" @click="sendSmsForRegister">发送验证码</span>
                </template>
            </van-field>

            <van-checkbox v-model="registerAgree" icon-size="14px" shape="square" checked-color="#7a69be" style="margin-top: 10px;">
                <div style="font-size: 12px;text-align: left;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">
                    我已阅读并同意
                    <span @click="openUserAgreement" style="color: #7a69be;">《用户协议》</span>
                    <span @click="openPrivacy" style="color: #7a69be;">《隐私政策》</span>
                </div>
            </van-checkbox>

            <van-button @click="submitRegister" type="info" round native-type="submit" :loading="loading"
                        style="width: 150px; height: 40px;margin-top: 10px;font-size: 14px;font-weight: bold"
                        loading-text="注册中" color="#7a69be">
                立即注册
            </van-button>
            <div v-if="registerType === 2" @click="registerType = 1" style="font-size: 13px;color: #888888;cursor: pointer;margin-top: 10px; user-select: none;">帐号密码注册</div>
            <div v-else  @click="registerType = 2" style="font-size: 13px;color: #888888;cursor: pointer;margin-top: 10px; user-select: none;">手机号码注册</div>
        </div>

        <div v-if="pageActive === 3" class="login-form">
            <van-field label-width="60" label="" style="background-color: rgba(122,105,190,0.03);margin-top: 0;"
                       :placeholder="`请输入${ this.webName }账号`" v-model="s_account" clearable>
            </van-field>

            <van-field label-width="60" type="password" label=""
                       style="background-color: rgba(122,105,190,0.03);margin-top: 5px;"
                       placeholder="请输入新密码" v-model="s_password" clearable/>

            <van-field label-width="60" type="password" label=""
                       style="background-color: rgba(122,105,190,0.03);margin-top: 5px;"
                       placeholder="请再次输入新密码" v-model="s_password1" clearable/>

            <van-field label-width="60" label="" v-model="s_code" type="number"
                       style="background-color: rgba(122,105,190,0.03);margin-top: 5px;"
                       placeholder="请输入验证码" clearable>
                <template #button>
                    <van-count-down
                        v-show="showCountDown"
                        ref="countDown"
                        :time="60000"
                        :auto-start="false"
                        format="重新发送(ss秒)"
                        style="font-size: 14px;color: #888888"
                        @finish="finish"
                    />
                    <span style="color: #7a69be;font-size: 13px;cursor: pointer" v-show="!showCountDown"
                          @click="sendSmsForReset">发送验证码</span>
                </template>
            </van-field>

            <van-button @click="submitReset" type="info" round native-type="submit" :loading="loading"
                        style="width: 150px; height: 40px;margin-top: 10px;font-size: 14px;font-weight: bold"
                        loading-text="正在提交" color="#7a69be">
                确认重置
            </van-button>
        </div>

        <div v-if="readDialogShow" class="my-read-dialog">
            <iframe v-show="true" class="iframe-box" :src="readUrl" frameborder="0" scrolling="y"
                    width="100%" height="100%"></iframe>
        </div>

    </div>
</template>

<script>

import {Dialog, Toast} from "vant";
import crypto from "@/utils/crypto";
import {request} from "@/api/request";
import notice from "@/api/notice";
import config from "@/api/config";

export default {
    name: 'HomeLogin',
    data() {
        return {
            pageActive: 1,

            account: '',
            password: '',

            r_account: '',
            r_password: '',
            r_password1: '',
            r_code: '',

            s_account: '',
            s_password: '',
            s_password1: '',
            s_code: '',

            accountPattern: /^[a-zA-Z0-9]{6,12}$/,
            telPattern: /^1[0-9]{10}$/,
            passwordPattern: /^(?=.*\d)(?=.*[a-zA-Z]).{6,20}$/,
            codePattern: /^\d{6}$/,
            registerType: 2,

            webName: '星游',
            loading: false,
            isLogin: false,
            showUserInfo: false,
            loginAgree: false,
            registerAgree: false,
            readDialogShow: false,
            readUrl: '',
            showCountDown: false,
            showResetPage: false,
            webConfig: {},
        };
    },
    mounted() {
        this.webConfig = config;
        this.initPage();
    },
    methods: {
        openUserAgreement() {
            notice.startIntent(this.webConfig.agreement);
        },
        openPrivacy() {
            notice.startIntent(this.webConfig.privacy);
        },
        initPage() {
            this.pageActive = 1;
            this.$nextTick(() => {
                if (window.WheelEvent) {
                    this.$refs.loginView.addEventListener('wheel', function (event) {
                        event.preventDefault();
                    }, {passive: false});
                }
            });
        },
        backLoginPage() {
            this.isRead = false;
            this.pageActive = 1;
            this.showResetPage = false;
        },
        toResetPage() {
            this.pageActive = 3;
            this.showResetPage = true;
        },
        submitLogin() {
            let ok = this.checkForm();
            if (ok !== 'ok') {
                Toast(ok);
                return;
            }
            this.loading = true;
            let options = {
                url: "/web/login",
                data: {
                    username: this.account,
                    password: crypto.encrypt(this.password),
                }
            };
            request(options).then(res => {
                this.loading = false;
                if (res.data.success) {
                    localStorage.setItem('web_token', res.data.data.token);
                    localStorage.setItem('web_user', JSON.stringify(res.data.data));
                    localStorage.setItem('web_username', res.data.data.userName);
                    localStorage.setItem('web_headerImg', res.data.data.headerImg || '');
                    Toast('登录成功');
                    this.$emit('login-success');
                } else {
                    Toast.fail(res.data.error.message);
                }
            });
        },
        submitReset() {
            let ok = this.checkResetForm();
            if (ok !== 'ok') {
                Toast(ok);
                return;
            }
            if (!this.codePattern.test(this.s_code)) {
                Toast("验证码为6位数字");
                return;
            }
            this.loading = true;

            let options = {
                url: "/web/resetPassword",
                data: {
                    newPassword: crypto.encrypt(this.s_password),
                    userName: this.s_account,
                    checkCode: this.s_code
                }
            };
            request(options).then((res) => {
                this.loading = false;
                if (res.data.success === true) {
                    Toast('密码重置成功');
                    this.backLoginPage();
                } else {
                    Toast(res.data.error.message);
                    this.finish();
                }
            });
        },
        sendSmsForRegister() {
            let ok = this.checkRegisterForSms();
            if (ok !== 'ok') {
                Toast(ok);
                return;
            }

            this.disabledSend = true;
            this.showSendText = false;
            this.showCountDown = true;
            this.$refs.countDown.start();
            let options = {
                url: "/web/sendSms",
                data: {
                    type: 1,
                    phone: this.r_account
                }
            };
            request(options).then((res) => {
                if (res.data.success === true) {
                    Toast('验证码发送成功');
                } else {
                    Toast(res.data.error.message);
                    this.finish();
                }
            });
        },
        sendSmsForReset() {
            let ok = this.checkResetForm();
            if (ok !== 'ok') {
                Toast(ok);
                return;
            }

            this.disabledSend = true;
            this.showSendText = false;
            this.showCountDown = true;
            this.$refs.countDown.start();
            let options = {
                url: "/web/sendSms",
                data: {
                    type: 2,
                    phone: this.s_account
                }
            };
            request(options).then((res) => {
                if (res.data.success === true) {
                    Toast('验证码发送成功');
                } else {
                    Toast(res.data.error.message);
                    this.finish();
                }
            });
        },
        finish() {
            this.disabledSend = false;
            this.showSendText = true;
            this.showCountDown = false;
            this.$refs.countDown.reset();
        },
        checkForm() {
            let ok = 'ok';
            if (!this.account) {
                ok = "请输入" + this.webName + "账号"
            } else if (!this.password) {
                ok = "请输入密码";
            } else if (!this.accountPattern.test(this.account)) {
                ok = this.webName + "账号为6-12位数字或字母";
            } else if (!this.passwordPattern.test(this.password)) {
                ok = "密码为6-20位同时包含数字字母";
            } else if (!this.loginAgree) {
                ok = '登录账号需要同意用户协议和隐私政策';
            }
            return ok;
        },
        submitRegister() {
            let ok = this.checkRegisterForm();
            if (ok !== 'ok') {
                Toast(ok);
                return;
            }
            this.loading = true;
            let options = {
                url: "/web/register",
                data: {
                    channelId: localStorage.getItem("channelId"),
                    username: this.r_account,
                    password: crypto.encrypt(this.r_password),
                    registerType: this.registerType,
                    smsCode: this.r_code,
                }
            };
            request(options).then(res => {
                this.loading = false;
                if (res.data.success) {
                    Toast('账号注册成功');
                    this.r_account = "";
                    this.r_password = "";
                    this.r_password1 = "";
                    this.r_code = "";
                    this.registerType = 2;
                    this.registerAgree = false;
                    this.pageActive = 1;
                } else {
                    Toast.fail(res.data.error.message);
                }
            });
        },
        checkRegisterForm() {
            if (this.registerType === 1) {//账号密码注册
                if (!this.r_account) {
                    return "请输入" + this.webName + "账号";
                }
                if (!this.accountPattern.test(this.r_account)) {
                    return this.webName + "账号为6-12位数字字母";
                }
                if (!this.r_password) {
                    return "请输入密码";
                }
                if (!this.passwordPattern.test(this.r_password)) {
                    return "密码为6-20位同时包含数字字母";
                }
                if (!this.r_password1) {
                    return "请再次输入密码";
                }
                if (this.r_password !== this.r_password1) {
                    return "两次密码输入不一致，请重新输入";
                }
            }
            else  {
                if (!this.r_account) {
                    return "请输入手机号码";
                }
                if (!this.telPattern.test(this.r_account)) {
                    return "请输入正确的手机号码";
                }
                if (!this.r_password) {
                    return "请输入密码";
                }
                if (!this.passwordPattern.test(this.r_password)) {
                    return "密码为6-20位同时包含数字字母";
                }
                if (!this.r_code) {
                    return "请输入验证码";
                }
                if (!this.codePattern.test(this.r_code)) {
                    return "验证码格式错误";
                }
            }

            if (!this.registerAgree) {
                return '账号注册需要同意用户协议和隐私政策';
            }
            return "ok";
        },
        checkRegisterForSms() {
            if (!this.r_account) {
                return "请输入手机号码";
            }
            if (!this.telPattern.test(this.r_account)) {
                return "请输入正确的手机号码";
            }
            if (!this.r_password) {
                return "请输入密码";
            }
            if (!this.passwordPattern.test(this.r_password)) {
                return "密码为6-20位同时包含数字字母";
            }
            return "ok";
        },
        checkResetForm() {
            if (!this.s_account) {
                return "请输入" + this.webName + "账号";
            }
            if (!this.accountPattern.test(this.s_account)) {
                return this.webName + "账号为6-12位数字字母";
            }
            if (!this.s_password) {
                return "请输入新密码";
            }
            if (!this.passwordPattern.test(this.s_password)) {
                return "密码为6-20位数字字母特殊符号";
            }
            if (!this.s_password1) {
                return "请再次输入新密码";
            }
            if (this.s_password !== this.s_password1) {
                return "两次新密码输入不一致，请重新输入";
            }
            return "ok";
        },
    }
};
</script>

<style scoped>
.main-border-header {
    background: transparent;
    //box-shadow: -4px 0 8px rgba(0, 0, 0, 0.2);
    //border-top-left-radius: 12px;
    //border-top-right-radius: 12px;
    border-bottom: 2px solid rgba(0, 0, 0, 0.05);
    overflow: hidden;
    padding: 5px 0;
}
.border-header-view {
    width: 260px;
    height: 40px;
    display: flex;
    align-items: flex-end;
    font-weight: bold;
    color: #888888;
    margin: 0 auto;
}
/*.item-left {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
}
.item-right {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
}*/
.border-view-item {
    width: 130px;
    height: 40px;
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
    background-color: #ffffff;
    //border: 2px solid #7a69be;
    color: #666666;
}
.item-activity {
    //background-color: #7a69be;
    color: #7a69be;
}

.login-form {
    padding: 10px 25px;
    color: #444444;
}

.login-form ::-webkit-input-placeholder {
    color: #888888;
}

.login-form :-moz-placeholder {
    color: #888888;
}

.login-form ::-moz-placeholder {
    color: #888888;
}

.ds-label {
    display: inline-block;
    width: 100%;
    text-align: left;
    margin: 5px 4px 0;
    font-size: 14px;
}

.login-view {
    width: 350px;
    height: 420px;
    background-color: #ffffff;
    border-radius: 12px;
    z-index: 1002;
    position: relative;
    margin: 50px auto 0;
}

.logo-img {
    width: 140px;
    margin-top: 10px;
}

.my-read-dialog {
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 1);
    position: absolute;
    top: 0;
    left: 0;
}
.van-field {
    outline: 1px #dbdbdb solid;
    border-radius: 3px;
}

.van-field:focus-within {
    outline: 2px #7a69be solid;
}

@media screen and (max-width: 900px) {
    .login-view {
        width: 80%;
        height: 420px;
        margin-top: 150px;
    }

    .logo-img {
        width: 110px;
        margin-top: 10px;
    }
}
</style>